import axiosInstance from '../../../config/axiosInstance';
const  CustomerDiscountService = {
    async GetAllCustomerDiscount(redirectCallback,ClientCompanyID) {
        try {            
           
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetCustomerDiscount?ID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
   async DeleteCustomerDiscount(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Customer/DeleteCustomerDiscount?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default CustomerDiscountService;